import { render, staticRenderFns } from "./personalEmailBox.vue?vue&type=template&id=cef15b80&scoped=true&"
import script from "./personalEmailBox.vue?vue&type=script&lang=js&"
export * from "./personalEmailBox.vue?vue&type=script&lang=js&"
import style0 from "./personalEmailBox.vue?vue&type=style&index=0&id=cef15b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef15b80",
  null
  
)

export default component.exports